<mat-toolbar class="app-header">
  <button 
    *ngIf="config.showMenuButton"
    mat-icon-button 
    class="menu-button"
    (click)="onMenuClick()">
    <mat-icon>menu</mat-icon>
  </button>
  <span class="app-title">{{ config.title }}</span>
</mat-toolbar> 